<div class="content-dash">
    <div class="title-top">
      <h1>{{ 'SUBSCRIPTIONS.TITLE' | translate }}</h1>
    </div>
  
    <app-suscription></app-suscription>
  </div>
  